import { selectIsRokuTemplatingFeatureFlagOn } from 'core/userContext';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { MessageTypeSelect, SettingsSectionHeader } from '../common';
import { displayContent } from '../common/content';
import { ExpirationTime } from './formFields/ExpirationTime';
import { ShowInInbox } from './formFields/ShowInInbox';
import { useQueryParamContext } from '../context/QueryParamContext';
import { TemplateNameField } from '../common/TemplateNameField';
import { InAppTabs } from './Tabs';
import { RokuFields } from './RokuFields';
import { AppAndBrowserFields } from './AppAndBrowserFields';
import { TABS } from './Tabs/types';
import { useInAppPreviewContext } from './context/InAppPreviewContext';
import { IN_APP_VIEW_OPTIONS } from './constants';

export const SettingsForm = () => {
  const { campaignId } = useQueryParamContext();
  const { previewViewOption, setPreviewViewOption } = useInAppPreviewContext();

  const [selectedTab, setSelectedTab] = useState<TABS>(TABS.APP_AND_BROWSER);
  const isCampaignFlow = !!campaignId;

  const isRokuTemplatingOn = useSelector(selectIsRokuTemplatingFeatureFlagOn);

  const SelectedContentFields =
    selectedTab === TABS.APP_AND_BROWSER ? <AppAndBrowserFields /> : <RokuFields />;

  useEffect(() => {
    if (selectedTab === TABS.ROKU) setPreviewViewOption(IN_APP_VIEW_OPTIONS.roku);
    if (selectedTab === TABS.APP_AND_BROWSER && previewViewOption === IN_APP_VIEW_OPTIONS.roku)
      setPreviewViewOption(IN_APP_VIEW_OPTIONS.inApp);
  }, [selectedTab]);

  return (
    <>
      {isCampaignFlow && (
        <>
          <SettingsSectionHeader>{displayContent.templateInformation}</SettingsSectionHeader>
          <TemplateNameField />
        </>
      )}

      <SettingsSectionHeader>{displayContent.headerSendingInformation}</SettingsSectionHeader>
      <MessageTypeSelect />
      <ExpirationTime />
      <ShowInInbox />

      {!isRokuTemplatingOn && <AppAndBrowserFields />}
      {isRokuTemplatingOn && (
        <>
          <InAppTabs selectedTab={selectedTab} setSelectedTab={setSelectedTab} />
          {SelectedContentFields}
        </>
      )}
    </>
  );
};

export default SettingsForm;
